const applied = [
  {
    path: '/approval/box/applied/vacation',
    component: () => import('@/page/approval/box/applied/VacationAppliedList.vue'),
    children: [
      {
        path: '/approval/box/applied/vacation/detail/:id',
        component: () => import('@/page/approval/box/applied/VacationAppliedDetail.vue'),
        meta: {
          name: '휴가 신청 상세',
          isMenu: false,
        },
      },
    ],
    meta: {
      name: '휴가 신청함',
      isMenu: false,
    },
  },
  {
    path: '/approval/box/applied/workhome',
    component: () => import('@/page/approval/box/applied/WorkHomeAppliedList.vue'),
    children: [
      {
        path: '/approval/box/applied/workhome/detail/:id',
        component: () => import('@/page/approval/box/applied/WorkHomeAppliedDetail.vue'),
        meta: {
          name: '재택근무 신청 상세',
          isMenu: false,
        },
      },
    ],
    meta: {
      name: '재택근무 신청함',
      isMenu: false,
    },
  },
  {
    path: '/approval/box/applied/outside',
    component: () => import('@/page/approval/box/applied/OutsideAppliedList.vue'),
    children: [
      {
        path: '/approval/box/applied/outside/detail/:id',
        component: () => import('@/page/approval/box/applied/OutsideAppliedDetail.vue'),
        meta: {
          name: '출장 및 외근 신청 상세',
          isMenu: false,
        },
      },
    ],
    meta: {
      name: '출장 및 외근 신청함',
      isMenu: false,
    },
  },
  {
    path: '/approval/box/applied/mealcost',
    component: () => import('@/page/approval/box/applied/MealCostAppliedList.vue'),
    children: [
      {
        path: '/approval/box/applied/mealcost/detail/:id',
        component: () => import('@/page/approval/box/applied/MealCostAppliedDetail.vue'),
        meta: {
          name: '식대비 신청 상세',
          isMenu: false,
        },
      },
    ],
    meta: {
      name: '식대비 신청함',
      isMenu: false,
    },
  },
  {
    path: '/approval/box/applied/expense',
    component: () => import('@/page/approval/box/applied/ExpenseAppliedList.vue'),
    children: [
      {
        path: '/approval/box/applied/expense/detail/:id',
        component: () => import('@/page/approval/box/applied/ExpenseAppliedDetail.vue'),
        meta: {
          name: '지출결의서 신청 상세',
          isMenu: false,
        },
      },
    ],
    meta: {
      name: '지출결의서 신청함',
      isMenu: false,
    },
  },
  {
    path: '/approval/box/applied/submit',
    component: () => import('@/page/approval/box/applied/SubmitAppliedList.vue'),
    children: [
      {
        path: '/approval/box/applied/submit/detail/:id',
        component: () => import('@/page/approval/box/applied/SubmitAppliedDetail.vue'),
        meta: {
          name: '품의서 신청 상세',
          isMenu: false,
        },
      },
    ],
    meta: {
      name: '품의서 신청함',
      isMenu: false,
    },
  },
  {
    path: '/approval/box/applied/holidaywork',
    component: () => import('@/page/approval/box/applied/HolidayWorkAppliedList.vue'),
    children: [
      {
        path: '/approval/box/applied/holidaywork/detail/:id',
        component: () => import('@/page/approval/box/applied/HolidayWorkAppliedDetail.vue'),
        meta: {
          name: '휴일근무 신청 상세',
          isMenu: false,
        },
      },
    ],
    meta: {
      name: '휴일근무 신청함',
      isMenu: false,
    },
  },
  {
    path: '/approval/box/applied/admit',
    component: () => import('@/page/approval/box/applied/AdmitAppliedList.vue'),
    children: [
      {
        path: '/approval/box/applied/admit/detail/:id',
        component: () => import('@/page/approval/box/applied/AdmitAppliedDetail.vue'),
        meta: {
          name: '인정휴가 지급 신청 상세',
          isMenu: false,
        },
      },
    ],
    meta: {
      name: '인정휴가 지급 신청함',
      isMenu: false,
    },
  },
  {
    path: '/approval/box/applied/businesstrip',
    component: () => import('@/page/approval/box/applied/BusinessTripAppliedList.vue'),
    children: [
      {
        path: '/approval/box/applied/businesstrip/detail/:id',
        component: () => import('@/page/approval/box/applied/BusinessTripAppliedDetail.vue'),
        meta: {
          name: '출장결과보고서 신청 상세',
          isMenu: false,
        },
      },
    ],
    meta: {
      name: '출장결과보고서 신청함',
      isMenu: false,
    },
  },
];

export default applied;
